import { render } from "./FeaturedProfilesHomepage.vue?vue&type=template&id=7f1d652f&scoped=true"
import script from "./FeaturedProfilesHomepage.vue?vue&type=script&lang=js"
export * from "./FeaturedProfilesHomepage.vue?vue&type=script&lang=js"

import "./FeaturedProfilesHomepage.vue?vue&type=style&index=0&id=7f1d652f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f1d652f"]])

export default __exports__